module.exports = __webpack_public_path__ + "static/media/photo-1508354486999-d33bd3cecc4c.4b01e3b6.jpeg";